import { Alert } from 'antd';

// shown above a prop's tabs while its maintenance setting is on, since a
// flood held in pending otherwise gives no hint why it hasn't started
export const MaintenanceBanner = ({ on }: { on?: boolean }) => on
	? <Alert banner type="warning" message="Maintenance mode is on. No new floods will start until it's turned off in Settings." />
	: null;
